import { BaseFetch } from "../main-model"
export default class ReportPersonelModel extends BaseFetch {
    getReportPersonelBy = (data) =>
    this.authFetch({
      url: "report-personel/getReportPersonelBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportPersonelAmountPersonelBy = (data) =>
    this.authFetch({
      url: "report-personel/getReportPersonelAmountPersonelBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportPersonelAmountRetireBy = (data) =>
    this.authFetch({
      url: "report-personel/getReportPersonelAmountRetireBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportPersonelAmountMoveBy = (data) =>
    this.authFetch({
      url: "report-personel/getReportPersonelAmountMoveBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportPersonelAmountGroupSubjectBy = (data) =>
    this.authFetch({
      url: "report-personel/getReportPersonelAmountGroupSubjectBy",
      method: "POST",
      body: JSON.stringify(data),
    })

    getReportPersonelAmountPositionBy = (data) =>
    this.authFetch({
      url: "report-personel/getReportPersonelAmountPositionBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
